import { render, staticRenderFns } from "./TryDifferentDomain.vue?vue&type=template&id=4057c5a2&scoped=true"
import script from "./TryDifferentDomain.vue?vue&type=script&lang=js"
export * from "./TryDifferentDomain.vue?vue&type=script&lang=js"
import style0 from "./TryDifferentDomain.vue?vue&type=style&index=0&id=4057c5a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4057c5a2",
  null
  
)

export default component.exports